import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api/lenders' 
  : 'http://localhost:5001/api/lenders';

/**
 * Get all lender settings
 */
export const getAllLenderSettings = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/settings`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch lender settings');
    }
  } catch (error) {
    console.error('Error fetching lender settings:', error);
    throw error.response?.data?.message || error.message || 'Failed to fetch lender settings';
  }
};

/**
 * Get active lenders for submission interface
 */
export const getActiveLenders = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/active`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch active lenders');
    }
  } catch (error) {
    console.error('Error fetching active lenders:', error);
    throw error.response?.data?.message || error.message || 'Failed to fetch active lenders';
  }
};

/**
 * Save/update lender settings (bulk save)
 */
export const saveLenderSettings = async (lenders) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/settings`, {
      lenders
    }, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to save lender settings');
    }
  } catch (error) {
    console.error('Error saving lender settings:', error);
    throw error.response?.data?.message || error.message || 'Failed to save lender settings';
  }
};

/**
 * Delete a specific lender
 */
export const deleteLenderSetting = async (lenderId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/settings/${lenderId}`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to delete lender');
    }
  } catch (error) {
    console.error('Error deleting lender:', error);
    throw error.response?.data?.message || error.message || 'Failed to delete lender';
  }
};

